import React from 'react';
import { renderToString } from 'react-dom/server';

import { FilePowerpointIcon } from '../../../icon/regular';
import {
  InstructionCSSClasses,
  InstructionEvent,
  InstructionActionTooltip,
} from '../types';
import { addInstructionEvent, emitInstructionEvent } from '../utils';
import BlockInstruction from '../base-instruction/BlockInstruction';

class DocumentInstructionBlock extends BlockInstruction {
  static initiable = false;

  get isInit() {
    return DocumentInstructionBlock.initiable;
  }

  set isInit(value: boolean) {
    DocumentInstructionBlock.initiable = value;
  }

  get instructionClasses() {
    return {
      wrapper: InstructionCSSClasses.DOCUMENT_PAGE_INSTRUCTION_BLOCK,
      action: InstructionCSSClasses.DOCUMENT_PAGE_INSTRUCTION_BLOCK_ACTION,
      content: InstructionCSSClasses.DOCUMENT_PAGE_INSTRUCTION_BLOCK_CONTENT,
    };
  }

  static get toolbox() {
    return {
      icon: renderToString(<FilePowerpointIcon style={{ height: 20 }} />),
      title: 'Document page',
    };
  }

  get tooltip() {
    return InstructionActionTooltip.documentPage;
  }

  openModal(instructionId: string) {
    emitInstructionEvent(
      this.api.events,
      InstructionEvent.OPEN_DOCUMENT_PAGE_INSTRUCTION_MODAL,
      {
        instructionId,
        isInline: false,
      },
    );
  }

  initEvents(): void {
    this.saveInstruction = this.saveInstruction.bind(this);
    addInstructionEvent(
      this.api.events,
      InstructionEvent.SAVE_DOCUMENT_PAGE_INSTRUCTION_BLOCK,
      this.saveInstruction,
    );
  }

  removeEvents(): void {
    this.api.events.off(
      InstructionEvent.SAVE_DOCUMENT_PAGE_INSTRUCTION_BLOCK,
      this.saveInstruction,
    );
  }
}

export default DocumentInstructionBlock;
